import config from '@/config'
import { httpClientPrivate } from '@/libs/httpClient'
import { useQuery } from '@tanstack/react-query'
import { FilterOptionResponse } from '../types'

const fetchFilterOptionTreatmentType = async () => {
  const response = await httpClientPrivate.get<FilterOptionResponse[]>(
    `${config.restUrl}/v1/backoffice/e-claim/filter-option/treatment-type`,
  )

  return response.data
}

const useFilterOptionTreatmentType = () => {
  const queryKey = ['useFilterOptionTreatmentType']
  const queryFn = async () => fetchFilterOptionTreatmentType()
  const queryResult = useQuery({ queryKey, queryFn })

  return { ...queryResult }
}

export { fetchFilterOptionTreatmentType, useFilterOptionTreatmentType }
